import { render, staticRenderFns } from "./ManageAttributes.vue?vue&type=template&id=4b95bcee&scoped=true"
import script from "./ManageAttributes.vue?vue&type=script&lang=js"
export * from "./ManageAttributes.vue?vue&type=script&lang=js"
import style0 from "./ManageAttributes.vue?vue&type=style&index=0&id=4b95bcee&prod&lang=scss&scoped=true"
import style1 from "./ManageAttributes.vue?vue&type=style&index=1&id=4b95bcee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b95bcee",
  null
  
)

export default component.exports